import { render, staticRenderFns } from "./MakeActiveModal.vue?vue&type=template&id=e187574a&"
import script from "./MakeActiveModal.vue?vue&type=script&lang=js&"
export * from "./MakeActiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports